module.exports = "//static.hsappstatic.net/livechat-unboxing-ui/static-1.6869/img/hubspot-tools-logo-dark.svg"